import { render, staticRenderFns } from "./CraftingCalculator.vue?vue&type=template&id=339a3eb8&"
import script from "./CraftingCalculator.vue?vue&type=script&lang=js&"
export * from "./CraftingCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports